import { useEffect, useState } from "react";
import { useDbClient, useLiveQuery } from "@tanstack/react-db";
import { requestUnavailable } from "@softmax/observatory-client/transport";
import { myPlayersCollection } from "@/features/players/records";
import { collectionError } from "@softmax/web-features/data";

import { useActualViewer } from "@softmax/web-features/session/records";

const idleLoadMs = 4_000;

export function usePillAccount({
  signedIn,
  needed,
}: {
  signedIn: boolean;
  needed: boolean;
}) {
  const [late, setLate] = useState(false);
  useEffect(() => {
    if (!signedIn) return;

    const timer = setTimeout(() => setLate(true), idleLoadMs);
    return () => clearTimeout(timer);
  }, [signedIn]);
  const account = useActualViewer();
  const viewerId = account.data?.subject_id ?? "anonymous";
  const descriptor = myPlayersCollection({
    viewerId,
    elevatedPrivileges: false,
  });
  const source = useDbClient().collection(descriptor);
  const enabled =
    signedIn && (needed || late) && account.data != null && !account.isError;
  const players = useLiveQuery((q) =>
    enabled ? q.from({ player: descriptor }) : undefined,
  );
  const playersError = collectionError(players.health);
  const unavailable = requestUnavailable(playersError);
  const agent = unavailable
    ? undefined
    : (players.data?.find((player) => player.is_default) ?? players.data?.[0]);
  return {
    account,
    players,
    playersError,
    refreshPlayers: () => {
      const read =
        players.isLoadingError && players.collection
          ? players.collection.reload()
          : source.utils.refetch({ throwOnError: true });
      return read.catch(() => undefined);
    },
    agent,
  };
}
